import gql from "graphql-tag";

export const GET_SELF_USER_CONNECTION_COUNTS_QUERY = gql`
  query {
    getSelfUserConnectionCounts {
      pendingSharedContacts
      connections
      pendingConnections
    }
  }
`;
